import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const ComplianceWrapper = (): ReactElement => <Outlet />;

export default ComplianceWrapper;
